import React, { useState } from "react";
// import { MdCall } from "react-icons/md";
import { Modal, Form } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import moment from "moment";
import { AiOutlineArrowDown } from "react-icons/ai";

import { CircularButtonView } from "../../../controls";
import { DataTable } from "../../../common";
import { AiFillEye } from "react-icons/ai";

const All = ({ data, initDoc, userDocument, downloadFile, getDocument }) => {
  // console.log(data)
  const [viewDetailsShow, setViewDetailsShow] = useState(false);
  const [viewDetails, setViewDetails] = useState(null);

  const columns = [
    {
      name: "Start Date",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>{moment(new Date(row.startDate)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      name: "End Date",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>{moment(new Date(row.endDate)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      name: "Status",
      center: true,
      grow: 4,
      cell: (row) => {
        if (row.status === 0) {
          return (
            <span className="badge bg-warning-transparent">
              Pending Approval
            </span>
          );
        }
        if (row.status === 1 ) {
          return <span className="badge bg-success-transparent"
          >
 {/* new commit */}
          {row.isAutoAvailed === true  ? 'Availed' : 'Approved'}

          </span>;
        }
        if (row.status === -1) {
          return <span className="badge bg-danger-transparent">Rejected</span>;
        }
        if (row.status === -2) {
          return <span className="badge bg-cancel-transparent">Cancelled</span>;
        }
      },
    },
    {
      name: "Type",
      selector: "masterLeaveType",
      center: true,
      grow: 4,
    },
    {
      name: "FD/1H/2H",
      selector: "leaveSubType",
      center: true,
      grow: 4,
    },
    // {
    //   name: 'Applier',
    //   selector: 'userId[0].firstName',
    //   center: true,
    //   grow: 4,
    // },
    {
      name: "Employee",
      center: true,
      grow: 4,
      cell: (row) => (
        <span>
          {row.userId[0].firstName} {row.userId[0].lastName.slice(0, 1)}
        </span>
      ),
    },
    {
      name: "Detail",
      center: true,
      minWidth: "80px",
      grow: 2,
      cell: (row) => (
        <div className="d-flex">
          <AiFillEye
            className="view"
            size={18}
            onClick={() => {
              handleViewOpen(row);
              if (row.attachementDocumentId) {
                getDocument(
                  row.employeeId[0],
                  true,
                  false,
                  row.attachementDocumentId
                );
              }
              // handleViewOpen()
            }}
          />
        </div>
      ),
    },
  ];

  const handleViewOpen = (row) => {
    setViewDetails(row);
    setViewDetailsShow(true);
    // console.log(row)
  };

  const handleClose = () => {
    setViewDetailsShow(false);
    initDoc();
  };
  // console.log("data", viewDetails);
  return (
    <>
      <div className="table_content px-2 attendance_table pb-3">
        <DataTable
          data={data}
          columns={columns}
          pagination={true}
          paginationPerPage={5}
          paginationServer={false}
        />
      </div>
      {viewDetails && (
        <div className="view_modal">
          <Modal
            show={viewDetailsShow}
            onHide={handleClose}
            aria-labelledby="view_modal"
          >
            <Modal.Header>
              <Modal.Title id="view_modal">Application Detail</Modal.Title>
              <div onClick={handleClose} style={{ cursor: "pointer" }}>
                <AiOutlineClose size={20} />
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="comments ms-1 d-flex justify-content-between align-items-center flex-wrap">
                <h5>
                  Applier:{" "}
                  <span style={{ color: "#d87d2e" }}>
                    {viewDetails.userId[0].firstName}{" "}
                    {viewDetails.userId[0].lastName}
                  </span>
                </h5>
                {viewDetails.masterLeaveType === "Optional Holiday Leave" && (
                  <h5>
                    <span
                      style={{ fontSize: "15px" }}
                      className="badge badge-success"
                    >
                      Optional Holiday
                    </span>
                  </h5>
                )}
              </div>
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  FD/1H/2H
                  <span>{viewDetails.leaveSubType}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Leave Type:
                  <span>{viewDetails.masterLeaveType}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Sub Leave Type:
                  <span>{viewDetails.leaveType.description}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Start Date:
                  <span>
                    {moment(new Date(viewDetails.startDate)).format(
                      "DD/MM/YYYY"
                    )}
                  </span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  End Date:
                  <span>
                    {moment(new Date(viewDetails.endDate)).format("DD/MM/YYYY")}
                  </span>
                </li>
                {viewDetails.comments && (
                  <div className="mt-3">
                    <div className="comments">
                      <h6>Comments:</h6>
                    </div>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        // disabled
                        readOnly
                        value={viewDetails.comments}
                        as="textarea"
                        rows={3}
                      />
                    </Form.Group>
                  </div>
                )}
                {userDocument ? (
                  <div className="d-flex justify-content-end mt-3">
                    <p className="mt-2">Download file</p>
                    <CircularButtonView
                      Icon={AiOutlineArrowDown}
                      onClick={() => {
                        downloadFile(userDocument.employeeId, userDocument._id);
                      }}
                      size={20}
                    />
                  </div>
                ) : (
                  ""
                )}
              </ul>
            </Modal.Body>
          </Modal>
        </div>
      )}
      {/* <div className="unapproved_modal">
        <Modal
          show={applyForLeaveShow}
          onHide={handleClose}
          aria-labelledby="filter_modal"
        >
          <Modal.Header>
            <Modal.Title id="filter_modal">All</Modal.Title>
            <div onClick={handleClose} style={{cursor: "pointer"}}>
              <AiOutlineClose size={20} />
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="comments">
              <h5>Comments</h5>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Veniam error facilis, et fugiat deleniti praesentium. Quibusdam modi laborum, non, voluptatum ab quisquam officia dicta aut exercitationem expedita quam veritatis sed.</p>
            </div>
            <ButtonView
              onClick={() => {}}
              title={"Cancel Leave"}
              styles="danger-outline"
            />
            <Button variant="danger">Cancel Leave</Button>
          </Modal.Body>
        </Modal>
      </div> */}
    </>
  );
};

export default All;
